import { render } from "./MfSnackbar.vue?vue&type=template&id=0346af98&scoped=true"
import script from "./MfSnackbar.vue?vue&type=script&lang=js"
export * from "./MfSnackbar.vue?vue&type=script&lang=js"

import "./MfSnackbar.vue?vue&type=style&index=0&id=0346af98&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0346af98"]])

export default __exports__